export default __webpack_public_path__ + "14701e212e7d88237496c68b1b9e5569.svg";